import BaseResource from './index'
import BoardResource from './board'
import UserResource from './user'

export default class LapTimeResource extends BaseResource {
    static endpoint = '/laps'

    static related() {
        return {
            user: UserResource,
            board: BoardResource,
        }
    }

    toString() {
        return `${this.attributes.hms} @ ${this.attributes.track_name}`
    }
}
